import { useCancelSubscriptionMutationApi } from '@aibees/shared/api';
import {
  CancelSubscriptionReason,
  ConfirmPlanDialogProps,
  FeedbackPlanDialogProps,
  ResultPlanDialogProps,
} from '@aibees/shared/definition';
import { useState } from 'react';
import { useCurrentSubscriptionApi } from '../../price-and-plan/api/use-current-subscription-api';
import { SubscriptionFlow, SubscriptionModalType } from '../types';
import { useSubscriptionModals } from './use-subscription-modals';

export function useDowngradeToFreeFlow(): SubscriptionFlow {
  const { activeModal, closeModal, openModal } = useSubscriptionModals();
  const { data } = useCurrentSubscriptionApi();
  const api = useCancelSubscriptionMutationApi(data && data?.current?.id);

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  // ---------------------------------- Handlers --------------------------------
  const handleStart = () => {
    openModal(SubscriptionModalType.CONFIRM_MODAL);
  };

  const handleConfirm = async () => {
    setIsLoading(true);
    openModal(SubscriptionModalType.COLLECT_FEEDBACK);
  };

  const handleCommentSubmit = (comment: string) => {
    api
      .mutateAsync({
        feedback: CancelSubscriptionReason.OTHER,
        comment,
      })
      .then(() => {
        openModal(null);
        window.location.hash = '#successFreeDowngrade';
      });
  };

  const handleFinalResult = () => {};
  // ---------------------------------- Handlers --------------------------------

  // ---------------------------------- Props --------------------------------
  const confirmDialogProps: ConfirmPlanDialogProps = {
    onConfirm: handleConfirm,
    onCancel: () => {},
  };

  const feedbackDialogProps: FeedbackPlanDialogProps = {
    onConfirm: handleCommentSubmit,
    onCancel: () => {},
  };

  const resultDialogProps: ResultPlanDialogProps = {
    onConfirm: handleFinalResult,
    onCancel: () => {},
  };
  // ---------------------------------- Props --------------------------------

  return {
    activeModal,
    onStart: handleStart,
    closeModal,
    confirmDialogProps,
    feedbackDialogProps,
    resultDialogProps,
  };
}
